/**
 * 商品ページ共通ユーティリティ関数
 * @version 1.0.0
 * 
 * Note: safeParseJSONはmetafield-loader.jsで定義されています
 */

(function() {
  'use strict';

  /**
   * 納期キーを表示用文字列に変換
   * productDeliveryCalcTypeに応じて「営業日」または「日」を使用
   * @param {string|number} deliveryKey - 納期キー（"1", "2", "3日", "5営業日" など）
   * @returns {string} 変換後の納期文字列
   */
  window.convertDeliveryKey = function(deliveryKey) {
    const calcType = window.productDeliveryCalcType || 'business_days';
    const suffix = (calcType === 'calendar_days') ? '日' : '営業日';
    
    // 既に「営業日」が含まれている場合
    if (String(deliveryKey).includes('営業日')) {
      return (calcType === 'calendar_days') 
        ? String(deliveryKey).replace('営業日', '日') 
        : String(deliveryKey);
    }
    
    // 「当日」系はそのまま返す
    if (String(deliveryKey).includes('当日')) {
      return String(deliveryKey);
    }
    
    // 全角数字を半角に変換
    const normalizedKey = String(deliveryKey).replace(/[０-９]/g, s => 
      String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    );
    
    // 「X日」形式（既に「日」が含まれる）
    if (normalizedKey.includes('日')) {
      const dayNum = normalizedKey.replace('日', '');
      return dayNum + suffix;
    }
    
    // 数値のみの場合
    if (!isNaN(normalizedKey)) {
      return normalizedKey + suffix;
    }
    
    // その他（翌営業日など）
    return String(deliveryKey);
  };

  /**
   * 価格をフォーマット（カンマ区切り）
   * @param {number} price - 価格
   * @returns {string} フォーマットされた価格文字列
   */
  window.formatPrice = function(price) {
    if (typeof price !== 'number' || isNaN(price)) {
      return '---';
    }
    return price.toLocaleString('ja-JP');
  };

  /**
   * 数量をフォーマット（カンマ区切り + 部）
   * @param {number} quantity - 数量
   * @returns {string} フォーマットされた数量文字列
   */
  window.formatQuantity = function(quantity) {
    if (typeof quantity !== 'number' || isNaN(quantity)) {
      return '---';
    }
    return quantity.toLocaleString('ja-JP') + '部';
  };

  /**
   * URLパラメータを取得
   * @returns {Object} URLパラメータのオブジェクト
   */
  window.getUrlParams = function() {
    const params = {};
    const searchParams = new URLSearchParams(window.location.search);
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  };

  /**
   * 価格マトリックスをネスト形式から配列形式に変換
   * @param {Object} nestedData - { 部数: { 納期: 価格 } } 形式のデータ
   * @param {string} variationCode - バリエーションコード
   * @returns {Array} 配列形式の価格データ
   */
  window.convertNestedPriceMatrix = function(nestedData, variationCode) {
    const priceData = [];
    
    for (const [quantityStr, deliveryPrices] of Object.entries(nestedData)) {
      const quantity = parseInt(quantityStr);
      
      if (typeof deliveryPrices === 'object' && deliveryPrices !== null) {
        for (const [deliveryKey, price] of Object.entries(deliveryPrices)) {
          const deliveryTime = window.convertDeliveryKey(deliveryKey);
          
          if (price && price > 0) {
            priceData.push({
              variation_code: variationCode,
              quantity: quantity,
              delivery_time: deliveryTime,
              base_price: price
            });
          }
        }
      }
    }
    
    return priceData;
  };

})();

